// Web shim for @react-native-firebase/analytics – no-op implementations

export const getAnalytics = () => ({});

export const logEvent = (_analytics: any, _name: string, _params?: any) => {
  // no-op on web
};

export const setUserId = (_analytics: any, _id: string | null) => {
  // no-op on web
};

export const setUserProperty = (
  _analytics: any,
  _name: string,
  _value: string | null,
) => {
  // no-op on web
};

export const setUserProperties = (
  _analytics: any,
  _properties: Record<string, string | null>,
) => {
  // no-op on web
};

export default {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperty,
  setUserProperties,
};
